import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";

import "./app-error.css";

const DEFAULT_MESSAGE = "We hit a snag. Please try again or head back home.";

const formatRouteError = (error) => {
  if (isRouteErrorResponse(error)) {
    const detail =
      typeof error.data === "string"
        ? error.data
        : error.data
          ? JSON.stringify(error.data, null, 2)
          : "";

    return {
      title: "Unexpected App Error",
      message: error.statusText || DEFAULT_MESSAGE,
      status: error.status,
      detail,
    };
  }

  if (error instanceof Error) {
    return {
      title: "Unexpected App Error",
      message: error.message || DEFAULT_MESSAGE,
      status: null,
      detail: error.stack || "",
    };
  }

  return {
    title: "Unexpected App Error",
    message: DEFAULT_MESSAGE,
    status: null,
    detail: typeof error === "string" ? error : "",
  };
};

export default function AppError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const { title, message, status, detail } = formatRouteError(error);

  return (
    <main className="app-error">
      <section className="app-error__card" role="alert" aria-live="polite">
        <h1 className="app-error__title">{title}</h1>
        <p className="app-error__message">{message || DEFAULT_MESSAGE}</p>
        {status ? <p className="app-error__status">Error {status}</p> : null}
        <div className="app-error__actions">
          <button
            className="app-error__button app-error__button--primary"
            type="button"
            onClick={() => navigate("/", { replace: true })}
          >
            Go home
          </button>
          <button
            className="app-error__button"
            type="button"
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        </div>
        {detail ? (
          <details className="app-error__details">
            <summary>Technical details</summary>
            <pre>{detail}</pre>
          </details>
        ) : null}
      </section>
    </main>
  );
}
